import { render, staticRenderFns } from "./ChannelPlanDetails.vue?vue&type=template&id=6b0d5e20&scoped=true"
import script from "./ChannelPlanDetails.vue?vue&type=script&lang=ts"
export * from "./ChannelPlanDetails.vue?vue&type=script&lang=ts"
import style0 from "./ChannelPlanDetails.vue?vue&type=style&index=0&id=6b0d5e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d5e20",
  null
  
)

export default component.exports